@if (infoContent() && infoContent().length) {
  <div class="infoSection">
    <pre>{{ infoContent() }}</pre>
  </div>
}
